import { render, staticRenderFns } from "./new-document.vue?vue&type=template&id=9ea5d438"
import script from "./new-document.vue?vue&type=script&lang=js"
export * from "./new-document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports